require('core-js');require('regenerator-runtime/runtime');require('./foundation/dgs-utils');

require('./feature/flex-spot');

require('./feature/flex-spot-gallery');

require('./feature/clickDimensions-form');

require('./project/header.js');

require('@demant/wdh-gdpr/lib/default.implementation.js');